import { request } from "@/util/request";

const apiShowcase = {
  apiGetAllShowcase(params) {
    return request({
      url: "/api/showcases",
      method: "get",
      params: params,
    });
  },
  apiGetDetailShowcase(showcaseId) {
    return request({
      url: `/api/showcases/${showcaseId}`,
      method: "get",
    });
  },
};
export default apiShowcase;
